import { findByBusiTypeV2 } from "@/api/common";

const dicDataV2 = {
  state: {
    dicDataV2Flag: ""
  },
  mutations: {
    SET_DICDATAV2FLAG(state, params) {
      state.dicDataV2Flag = params;
    }
  },
  actions: {
    getDicDataV2Flag({commit},params){
      findByBusiTypeV2(params).then(res=>{
        if (res.data.businId == params) {
          let dicDataV2Flag = res.data.businName == 1;
          commit("SET_DICDATAV2FLAG", dicDataV2Flag);
        }
      });
    }
  }
};
export default dicDataV2;


// WEBPACK FOOTER //
// ./src/store/modules/dicDataV2.js